import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { UserState } from '../user/UserState';
import { IRecordingStats } from '@innerhive-internal/innerhive-common';

const recordingStatsMediaType = 'application/vnd.innerhive.user-note-stats.v1+json';

interface IRecordingStatsAPIResponse {
    successfulSummaries: number;
    totalWords: number;
    totalMsDuration: number;
}

export class RecordingStatsClient {
    static inject = () => [APIClient, UserState];

    constructor(
        private apiClient: APIClient,
        private userState: UserState
    ) {}

    getRecordingStats = async (): Promise<IRecordingStats> => {
        if (!this.userState.state.links?.notesStats) {
            throw new Error('Notes stats link not available');
        }

        const response: IRecordingStatsAPIResponse = await this.apiClient.get(
            this.userState.state.links.notesStats,
            recordingStatsMediaType
        );

        // Calculate derived stats
        const minutesSaved = Math.round((response.totalWords / 150) / 2);
        const pagesAvoided = Math.round(response.totalWords / 250);

        return {
            successfulSummaries: response.successfulSummaries,
            totalWords: response.totalWords,
            totalMsDuration: response.totalMsDuration,
            minutesSaved,
            pagesAvoided
        };
    };
}
